import React from 'react';

import { compose, isEmpty, map, reject, split, trim } from 'lodash/fp';
import PropTypes from 'prop-types';

import FormControl from './FormControl';

const propTypes = {
    autoFocus: PropTypes.bool,
    required: PropTypes.bool,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func.isRequired,
};

const formatValue = compose(reject(isEmpty), map(trim), split(','));

/**
 * @deprecated Use CsvInput2
 */
class CsvInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value.join(', '),
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSave = this.handleSave.bind(this);
    }

    componentDidUpdate(prevProps) {
        const { value } = this.props;
        if (value !== null && value !== prevProps.value) {
            this.handleChange({ target: { value: value.join(', ') } });
        }
    }

    handleChange(ev) {
        this.setState({ value: ev.target.value });
    }

    handleSave(ev) {
        const name = ev.target.name;
        const value = formatValue(ev.target.value);
        this.props.onChange({ target: { name, value } });
    }

    render() {
        const { autoFocus, required, name, placeholder } = this.props;

        return (
            <FormControl
                autoFocus={!!autoFocus}
                required={!!required}
                type="text"
                name={name}
                placeholder={placeholder}
                value={this.state.value}
                onChange={this.handleChange}
                onBlur={this.handleSave}
            />
        );
    }
}

CsvInput.propTypes = propTypes;

export default CsvInput;
